import React from "react";
import { Row } from "antd";

export const Settings = () => {
  return <Row gutter={[24, 0]} align="top" justify="center"></Row>;
};
